export default "__VITE_ASSET__Ctz93tpT__"